"use strict";
var $ = require("../internals/export");
var isObject = require("../internals/is-object");
var onFreeze = require("../internals/internal-metadata").onFreeze;
var FREEZING = require("../internals/freezing");
var fails = require("../internals/fails");
var $preventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES = fails(function() {
  $preventExtensions(1);
});
$({ target: "Object", stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
  }
});
